import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import style from './style.module.scss';
import logo from '../../../assets/logos/logo.svg'
import logoText from '../../../assets/logos/logo_nexora.svg'

export function Footer() {
    const { t } = useTranslation();

    const [openColumn, setOpenColumn] = useState(null);

    const footerLinks = t('footer.columns', { returnObjects: true });

    const toggleColumn = (title) => {
        setOpenColumn(prev => (prev === title ? null : title));
    };

    return (
        <footer className={style["footer"]}>
            <div className={style["footer__inner"]}>
                <div className={`container ${style["footer__top"]}`}>
                    <div className={style["footer__brand"]}>
                        <div className={style["footer__logo"]}>
                            <img
                                className={style['footer__logo-img']}
                                src={logo}
                                alt="Nexora"
                            />

                            <img
                                className={style['footer__logo-text']}
                                src={logoText}
                                alt=""
                            />
                        </div>

                        <p>
                            {t('footer.description.line1')}
                            <br />
                            {t('footer.description.line2')}
                        </p>
                    </div>

                    <div className={style["footer__columns"]}>
                        {footerLinks.map((column) => {
                            const isOpen = openColumn === column.title;

                            return (
                                <div
                                    key={column.title}
                                    className={`${style["footer__column"]} ${isOpen ? style["footer__column--open"] : ''}`}
                                >
                                    <button
                                        type="button"
                                        className={style["footer__column-head"]}
                                        onClick={() => toggleColumn(column.title)}
                                        aria-expanded={isOpen}
                                    >
                                        <h4>{column.title}</h4>
                                        <span
                                            className={style["footer__chevron"]}
                                            aria-hidden="true"
                                        />
                                    </button>

                                    <div className={style["footer__column-body"]}>
                                        <ul>
                                            {column.links.map((item) => (
                                                <li key={item.name}>
                                                    <a href={item.link}>
                                                        {item.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div className={style["footer__divider"]} />

                <div className={`container ${style["footer__bottom"]}`}>
                    <span>{t('footer.copyright')}</span>

                    <a href="mailto:info@nexoralab.biz">
                        {t('footer.email')}
                    </a>
                </div>
            </div>
        </footer>
    )
}